import { SearchInput, SearchInputProps } from './SearchInput';
import { FormEvent } from 'react';

export function SearchForm(props: SearchInputProps) {
   function preventDefaultBehavior(e: FormEvent<HTMLFormElement>) {
      e.preventDefault();
   }

   return (
      <form role="search" onSubmit={preventDefaultBehavior}>
         <SearchInput {...props} />
      </form>
   );
}
